<mat-toolbar>
  Registros
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="reload()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="Albarán, transportista, matrícula, cliente..." (keyup)="applyFilter($event)">
    </mat-form-field>
    <div class="tableHeaderFilters">
      <mat-form-field class="filterSelect searchMobile">
        <mat-label>Tipo</mat-label>
        <mat-select [(value)]="recordTypeFilter" (selectionChange)="onRecordTypeChange()">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="pesaje">Solo pesajes</mat-option>
          <mat-option value="movement">Solo movimientos</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filterSelect searchMobile">
        <mat-label>Tipo movimiento</mat-label>
        <mat-select [(value)]="movementTypeFilter" (selectionChange)="onMovementTypeChange()" [disabled]="movementTypeFilterDisabled">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="entrega">Entrega</mat-option>
          <mat-option value="retirada">Retirada</mat-option>
          <mat-option value="cambio">Cambio</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filterSelect searchMobile">
        <mat-label>Báscula</mat-label>
        <mat-select [(value)]="scaleFilter" (selectionChange)="applyScaleFilter()" [disabled]="pesajeFiltersDisabled">
          <mat-option value="all">Todas</mat-option>
          @for (scale of scales; track scale) {
            <mat-option [value]="scale.id.toString()">{{scale.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filterSelect searchMobile">
        <mat-label>Clasificado</mat-label>
        <mat-select [(value)]="clasificado" (selectionChange)="onClasificadoChange()" [disabled]="pesajeFiltersDisabled">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="true">Clasificado</mat-option>
          <mat-option value="false">Sin clasificar</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="fechaFin" matSortDirection="desc" (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef> Tipo </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)"> {{tipoLabel(element)}} </td>
      </ng-container>
      <ng-container matColumnDef="albaran">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Albarán </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)"> {{element.albaran}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaInicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha inicio </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          {{element.fechaInicio}}
          @if (element.type === 'pesaje') {
            <span>h.</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="fechaFin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha final </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          {{element.fechaFin}}
          @if (element.type === 'pesaje') {
            <span>h.</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="transportistas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transportistas </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          @if (element.type === 'pesaje') {
            <span>{{element.transportistas}}</span>
          } @else {
            <span>-</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="matriculas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Matrículas / Contenedores </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          @if (element.type === 'pesaje') {
            <span>{{element.matriculas}}</span>
          }
          @if (element.type === 'movement') {
            @if (element.typeMovement === 'entrega') {
              <mat-icon class='green miniIcon' matTooltip="Entrega">arrow_forward</mat-icon>
              <span>{{element.transportistas}}</span>
            }
            @if (element.typeMovement === 'retirada') {
              <mat-icon class='green miniIcon' matTooltip="Retirada">arrow_back</mat-icon>
              <span>{{element.matriculas}}</span>
            }
            @if (element.typeMovement === 'cambio') {
              <mat-icon class='green miniIcon' matTooltip="Entrega">arrow_forward</mat-icon>
              <span>{{element.transportistas}}</span>
              <br>
              <mat-icon class='orange miniIcon' matTooltip="Retirada">arrow_back</mat-icon>
              <span>{{element.matriculas}}</span>
            }
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="scales">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Báscula </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)"> {{element.scales}} </td>
      </ng-container>
      <ng-container matColumnDef="clasificado">
        <th mat-header-cell *matHeaderCellDef> Clasificado </th>
        <td mat-cell *matCellDef="let element" (dblclick)="verRegistro(element)">
          @if (element.clasificado === 'true') {
            <mat-icon class='green' matTooltip="Clasificado">fiber_manual_record</mat-icon>
          }
          @if (element.clasificado === 'false') {
            <mat-icon class='red' matTooltip="Sin clasificar">fiber_manual_record</mat-icon>
          }
          @if (element.clasificado !== 'true' && element.clasificado !== 'false') {
            <span>-</span>
          }
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="8">No existen registros...<br></td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator
    [length]="totalRecords"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pages"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>
</div>
